import { Client } from '@/api/models/Client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ClientState {
  clients: Client[] | [];
  loading: boolean;
  error: string | null;
}

const initialState: ClientState = {
  clients: [],
  loading: false,
  error: null,
};

const clientSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    fetchClientsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchClientsSuccess(state, action: PayloadAction<Client[]>) {
      state.loading = false;
      state.clients = action.payload;
    },
    fetchClientsFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchClientsStart, fetchClientsSuccess, fetchClientsFailure } = clientSlice.actions;

export default clientSlice.reducer;
